// ─── Shirt Type Circular Cards ────────────────────────────────────────────────

export interface EPLShirtType {
  title: string
  img: string
  url: string
}

export const EPL_SHIRT_TYPES: EPLShirtType[] = [
  { title: 'Home Shirts', img: '/images/epl/home-shirts.jpg', url: 'home-shirts' },
  { title: 'Away Shirts', img: '/images/epl/away-shirts.jpg', url: 'away-shirts' },
  { title: 'Third Shirts', img: '/images/epl/third-shirts.jpg', url: 'third-shirts' },
  { title: 'Goalkeeper', img: '/images/epl/goalkeeper.jpg', url: 'goalkeeper' },
  { title: 'Hero Shirts', img: '/images/epl/hero-shirts.jpg', url: 'hero-shirts' },
  { title: 'Jackets', img: '/images/epl/jackets.jpg', url: 'jackets' },
  { title: 'Training Kits', img: '/images/epl/training-kits.jpg', url: 'training-kits' },
  { title: 'Shorts', img: '/images/epl/shorts.jpg', url: 'shorts' },
  { title: 'T-Shirts', img: '/images/epl/t-shirts.jpg', url: 't-shirts' },
  { title: 'Retro Shirts', img: '/images/epl/retro-shirts.jpg', url: 'retro-shirts' },
  { title: 'Hoodies', img: '/images/epl/hoodies.jpg', url: 'hoodies' },
  { title: 'Pants', img: '/images/epl/pants.jpg', url: 'pants' },
  { title: 'Socks', img: '/images/epl/socks.jpg', url: 'socks' },
  { title: 'Caps', img: '/images/epl/caps.jpg', url: 'caps' },
  { title: 'Rugby Shirts', img: '/images/epl/rugby-shirts.jpg', url: 'rugby-shirts' },
  { title: 'Mugs', img: '/images/epl/mugs.jpg', url: 'mugs' },
]

// ─── Popular English Teams ────────────────────────────────────────────────────

export interface EPLTeam {
  label: string
  href: string
}

export const EPL_TEAMS: EPLTeam[] = [
  { label: 'Arsenal', href: '/football-shirts/english-premier-league/arsenal' },
  { label: 'Aston Villa', href: '/football-shirts/english-premier-league/aston-villa' },
  { label: 'Birmingham', href: '/football-shirts/english-premier-league/birmingham' },
  { label: 'Blackburn', href: '/football-shirts/english-premier-league/blackburn' },
  { label: 'Bolton', href: '/football-shirts/english-premier-league/bolton' },
  { label: 'Championship', href: '/football-shirts/english-premier-league/championship' },
  { label: 'Chelsea', href: '/football-shirts/english-premier-league/chelsea' },
  { label: 'Everton', href: '/football-shirts/english-premier-league/everton' },
  { label: 'Fulham', href: '/football-shirts/english-premier-league/fulham' },
  { label: 'Hull', href: '/football-shirts/english-premier-league/hull' },
  { label: 'League One', href: '/football-shirts/english-premier-league/league-one' },
  { label: 'League Two', href: '/football-shirts/english-premier-league/league-two' },
  { label: 'Liverpool', href: '/football-shirts/english-premier-league/liverpool' },
  { label: 'Manchester City', href: '/football-shirts/english-premier-league/man-city' },
  { label: 'Manchester United', href: '/football-shirts/english-premier-league/man-utd' },
  { label: 'Middlesbrough', href: '/football-shirts/english-premier-league/middlesborough' },
  { label: 'Newcastle', href: '/football-shirts/english-premier-league/newcastle' },
  { label: 'Non-League', href: '/football-shirts/english-premier-league/non-league' },
  { label: 'Portsmouth', href: '/football-shirts/english-premier-league/portsmouth' },
  { label: 'Stoke', href: '/football-shirts/english-premier-league/stoke-city' },
  { label: 'Sunderland', href: '/football-shirts/english-premier-league/sunderland' },
  { label: 'Tottenham', href: '/football-shirts/english-premier-league/tottenham' },
  { label: 'West Brom', href: '/football-shirts/english-premier-league/west-brom' },
  { label: 'West Ham', href: '/football-shirts/english-premier-league/west-ham' },
  { label: 'Wigan', href: '/football-shirts/english-premier-league/wigan' },
]

// ─── Shop by Player ──────────────────────────────────────────────────────────

export interface EPLPlayer {
  name: string
  count: string
  href: string
}

export const EPL_PLAYERS: EPLPlayer[] = [
  { name: 'Alexsander Isak', count: '196 products', href: '/results/alexsander-isak' },
  { name: 'Bruno Fernandes', count: '144 products', href: '/results/bruno-fernandes' },
  { name: 'Alejandro Garnacho', count: '141 products', href: '/results/alejandro-garnacho' },
  { name: 'Alex Greenwood', count: '129 products', href: '/results/alex-greenwood' },
  { name: 'Bobby Charlton', count: '128 products', href: '/results/bobby-charlton' },
  { name: 'Bernardo Silva', count: '118 products', href: '/results/bernardo-silva' },
  { name: 'Casemiro', count: '112 products', href: '/results/casemiro' },
  { name: 'Bukayo Saka', count: '111 products', href: '/results/bukayo-saka' },
  { name: 'CHLOE KELLY', count: '108 products', href: '/results/chloe-kelly' },
  { name: 'Abdukodir Khusanov', count: '104 products', href: '/results/abdukodir-khusanov' },
  { name: 'Claudio Echeverri', count: '87 products', href: '/results/claudio-echeverri' },
]

// ─── USP Strip ───────────────────────────────────────────────────────────────

export interface EPLUspItem {
  id: string
  heading: string
  text: string
  icon: 'licensed' | 'delivery' | 'personal' | 'returns'
}

export const EPL_USP_ITEMS: EPLUspItem[] = [
  {
    id: 'licensed',
    heading: 'Licensed Merchandise',
    text: "All our products are authentic, licensed, and ship from our UK warehouse. We don't sell fakes.",
    icon: 'licensed',
  },
  {
    id: 'delivery',
    heading: 'Fast Worldwide Delivery',
    text: 'We offer worldwide shipping: next day to Europe, 2 days to the USA, and 3-4 days elsewhere.',
    icon: 'delivery',
  },
  {
    id: 'personal',
    heading: 'Make it Personal',
    text: 'Customize any kit with player-style name and number printing. Choose any name, including your own.',
    icon: 'personal',
  },
  {
    id: 'returns',
    heading: 'Easy Returns Process',
    text: 'Return within 28 days via our online center if unsatisfied (excludes personalized items).',
    icon: 'returns',
  },
]

// ─── FAQ ─────────────────────────────────────────────────────────────────────

export interface EPLFaqItem {
  id: string
  question: string
  answer: string
}

export interface EPLFaqCategory {
  id: string
  label: string
  items: EPLFaqItem[]
}

export const EPL_FAQ_CATEGORIES: EPLFaqCategory[] = [
  {
    id: 'shipping',
    label: 'Shipping & delivery',
    items: [
      {
        id: 'shipping-1',
        question: 'How long does shipping take?',
        answer:
          'The majority of our shirts are available for next day dispatch, however as we have over 100,000 products on our website, additional lead times do apply to some. Please check our shipping info page for our full shipping details.',
      },
      {
        id: 'shipping-2',
        question: 'What are your international shipping rates?',
        answer:
          'We ship worldwide and offer a range of delivery options to suit your needs. We utilise a range of couriers including Royal Mail, PostNL, Hermes, Norsk Global, DPD, Deutsche Poste and Hermes. We offer tracked and express shipping to all countries. Please visit our shipping info page and select your country from the "International Deliveries" section for the latest rates.',
      },
      {
        id: 'shipping-3',
        question: 'Do you offer express delivery options?',
        answer:
          'Yes, we offer next day delivery on eligible items to the UK and 1-3 day shipping to the rest of the world depending on your shipping location.',
      },
      {
        id: 'shipping-4',
        question: 'Can I track my order?',
        answer: 'Yes, all our orders are sent via a fully tracked service.',
      },
      {
        id: 'shipping-5',
        question: 'Where do you ship from?',
        answer: 'All orders are shipped from our UK based warehouse.',
      },
      {
        id: 'shipping-6',
        question: 'What happens if my package is lost?',
        answer:
          'If your package is lost in transit, please contact our customer service team. We will investigate and provide a replacement or full refund.',
      },
    ],
  },
  {
    id: 'customisation',
    label: 'Customisation',
    items: [
      {
        id: 'custom-1',
        question: 'How do I add a name and number to my shirt?',
        answer:
          "You can find a wide range of pre-printed football shirts for all your favourite stars such as Messi, Ronaldo, Wirtz, Salah, Haaland, Mbappe, Saka, Rice, Vinicus and hundreds more stars in our hero shirts section. Alternatively, all our shirts come with the option to add a custom name and number to them. When you see a 'Name and Number' Box on the product page, simply add your desired name and number in the following format - RONALDO 7 and we will print your shirt in the correct printing style.",
      },
      {
        id: 'custom-2',
        question: 'What printing styles do you have?',
        answer:
          'We have all the latest styles for all the major club and international teams. We have the current Premiership, La Liga, Serie A, SPL, Bundesliga, Ligue 1, Eredivise, Super Liga and MLS prints, as well as the latest Nike, Puma, Adidas, Umbro and Kappa international name and numbers. We also have club specific prints for all the major teams including Barcelona, Real Madrid, Inter Milan, Juventus and more.',
      },
      {
        id: 'custom-3',
        question: 'Can I send an existing football shirt to you for printing?',
        answer:
          'We are happy to print shirts you send to us. Please contact us beforehand to check the printing style\'s availability and confirm costs. Before sending your shirt to us, please ensure that the shirt is washed.',
      },
      {
        id: 'custom-4',
        question: 'Do you sell official sleeve patches?',
        answer:
          'In addition to our football shirt printing services, we also offer a range of sleeve patches including UEFA Champions League, Premiership, Bundesliga, La Liga, Serie A and Ligue 1. We also provide club specific badges such as Serie A Scudetto patch, Premier League Champions badge as well as the Champions League winners patches.',
      },
      {
        id: 'custom-5',
        question: 'Are there any restrictions on what I can print?',
        answer:
          'We reserve the right to refuse any customisation requests that contain offensive, inappropriate, or trademarked content.',
      },
    ],
  },
  {
    id: 'other',
    label: 'Returns & Store Info',
    items: [
      {
        id: 'other-1',
        question: 'What is your return policy?',
        answer:
          'We offer a 28-day return policy for unworn items in original packaging. Personalised and printed items cannot be returned unless there is a manufacturing defect.',
      },
      {
        id: 'other-2',
        question: 'What payment methods do you accept?',
        answer:
          'We accept all major credit cards, PayPal, Klarna, Clearpay, Alipay and other local payment methods. All transactions are secure, encrypted, and processed via Stripe.',
      },
      {
        id: 'other-3',
        question: 'Are your products authentic?',
        answer:
          'Since 2004, UKSoccershop has been one of the largest, most trusted football shirt providers in the world. Everything we sell is fully authentic.',
      },
    ],
  },
]

// ─── Page Metadata ────────────────────────────────────────────────────────────

export const EPL_DESCRIPTION =
  'Browse our selection of Premiership football shirts. We have one of the most complete collections of premiership shirts available to buy online with all our shirts having official printing and patches available for them. Our top selling shirts are Man Utd shirts, Chelsea shirts, Liverpool shirts, Arsenal shirts and Spurs shirts.'
